import React from 'react';
import classNames from 'classnames';
import css from './ModalContainer.module.css';
import { ClickOutsideCallback, useClickOutside } from '@mm/hooks';

interface IModalContainer {
  className?: string;
  onOutsideClick?: ClickOutsideCallback;
}

export const ModalContainer: React.FC<IModalContainer> = ({
  className,
  children,
  onOutsideClick = () => {},
}) => {
  const ref = useClickOutside<HTMLDivElement>(onOutsideClick);

  return (
    <div ref={ref} className={classNames(css.container, className)}>
      {children}
    </div>
  );
};
